<app-toast-message [justAfterLogin]="false"></app-toast-message>

<main class="container-fluid h-100 p-0 login" [attr.aria-labelledby]="resetFormEnabled ? 'fp_title': 'login_title'">

  <app-preloader *ngIf="loginLoader" class="w-100 h-100 position-fixed preloader-backdrop" [loaderText]="'Login...'">
  </app-preloader>

  <section id="login" class="row justify-content-center align-items-center h-100">

    <div class="col-8 col-md-8 col-lg-6 col-xl-6">
      <div class="row">
        <div class="offset-md-1 col-md-10 col-lg-8 offset-lg-2">

          <div class="row login--heading logo">
            <div class="col-12 d-flex justify-content-between align-items-center p-0">
              <div class="col-auto">
                <h1 id="loginText" aria-atomic="true">
                  <span id="fp_title" *ngIf="resetFormEnabled">Forgot Password</span>
                  <span id="login_title" *ngIf="!resetFormEnabled && !passwordReset">Log in</span>
                  <span *ngIf="passwordReset">Thank You</span>
                </h1>
              </div>
              <div class="col-auto">
                <img src="assets/images/logo.svg#logo" alt="Learningmate - Frost align" />
              </div>
            </div>
          </div>
          <p class="mb-0"></p>
          <!-- this is a hack for accessibility. dont remove this p -->
          <p class="font-bold" role="alert" *ngIf="passwordReset">An email is sent to you with further instructions</p>

          <div class="row p-0" *ngIf="!passwordReset">
            <div class="form-group col-12 my-0">
              <label for="emailID" class="font-bold">User</label>
              <input type="text" class="form-control font-bold" name="emailID" id="emailID" [(ngModel)]="userEmail"
                [formControl]="form.controls['username']" aria-label="Please enter your Email ID" aria-required="true"
                (click)="click()" (keyup)="onModelChange()">
              <div class="error--txt" *ngIf="form.controls['username'].touched && form.controls['username'].invalid"
                role="alert">
                <p class="font-bold m-0 d-flex align-items-center mt-1">
                  <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                  Invalid email
               </p>
              </div>
            </div>

            <div class="form-group col-12 my-0" *ngIf="!resetFormEnabled">
              <label for="password" class="font-bold">Password</label>
              <input type="password" class="form-control font-bold" name="password" id="password"
                [formControl]="form.controls['password']" aria-label="Please enter your password" aria-required="true"
                (click)="click()" (keyup.enter)="signin()">
              <div class="error--txt"
                *ngIf="form.controls['password'].hasError('required') && form.controls['password'].touched"
                role="alert">
                <p class="font-bold m-0 d-flex align-items-center mt-1">
                  <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                  Password is required
               </p>
              </div>
            </div>
          </div>


          <div class="row align-items-center login--btn-set">
            <div class="col" *ngIf="!passwordReset">
              <button type="button" class="btn btn-primary btn__login" id="signinBtn" (click)="signin()"
                [disabled]="!form.valid || loginLoader" *ngIf="!resetFormEnabled">Log in</button>
                <p class="mb-0"></p><!-- this is a hack for accessibility. dont remove this p -->
              <button type="button" class="btn btn-primary btn-login" id="resetPasswordBtn" (click)="resetPassword()"
                [disabled]="!enableResetButton" *ngIf="resetFormEnabled">Reset
                Password</button>
                <p class="mb-0"></p><!-- this is a hack for accessibility. dont remove this p -->
            </div>

            <div class="col text-right" *ngIf="!passwordReset">
              <button class="btn text-underline btn-link-text" id="bcktologinBtn" (click)="cancel()"
                *ngIf="resetFormEnabled">Back
                to Login</button>
              <button class="btn text-underline btn-link-text" id="btnPasswordLost" (click)="resetPasswordForm()"
                *ngIf="!resetFormEnabled">Forgot your
                password?</button>
            </div>

            <div class="col" *ngIf="passwordReset">
              <button type="button" class="btn btn-primary btn-sm" id="redirectToLoginBtn"
                (click)="redirectToLogin()">Ok</button>
            </div>
          </div>

          <hr aria-hidden="true">

          <div class="col-12 p-0">
            <p class="font-bold">Don't have an account?
              <button class="btn text-underline btn-link-text" id="btnRegister" (click)="navigateToRegister();">Click
                here to register!</button>
            </p>
          </div>
        </div>

      </div>

    </div>

  </section>


</main>
